import { Card, Typography, Box } from "@mui/material";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";

export default function ErrorScreen() {
    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#f9fafb",
            }}
        >
            <Card
                variant="outlined"
                sx={{
                    padding: 4,
                    maxWidth: 420,
                    textAlign: "center",
                    borderRadius: 3,
                }}
            >
                <CancelRoundedIcon
                    sx={{ fontSize: 80, color: "error.main", mb: 2 }}
                />

                <Typography variant="h5" fontWeight={600} gutterBottom>
                    Stripe Account Connection Failed
                </Typography>

                <Typography color="error" mb={3}>
                    We couldn’t connect your Stripe account.
                    Please try again or contact support if the issue persists.
                </Typography>
            </Card>
        </Box>
    );
}